import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Quake, MapCoordinate } from './quake';

export class Bound {
  n: number;
  s: number;
  e: number;
  w: number;

  constructor(n: number, e: number, s: number, w: number) {
    this.n = n;
    this.e = e;
    this.s = s;
    this.w = w;
    return this;
  }
}

export class ImageCoordinate {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}

export class Region {
  name: string;
  bound: Bound;
  asset: string;
  image: HTMLImageElement;
  miniMapUrl: string;
  events: Array<Quake>;
  minMagnitudeToShow: number;
  hideRegion: boolean;
  slideDuration: number;
  showTerminator: boolean;
  antemeridian: boolean;
  constructor() {
    this.hideRegion = false
    this.minMagnitudeToShow = 3;
    this.slideDuration = 30000;
    this.events = [];
    this.bound = new Bound(1, 1, 1, 1);
  }

  private latDegPixels: number;
  private lngDegPixels: number;

  latLng2Pixel(quake: Quake | MapCoordinate): ImageCoordinate | null {
    // Outside of the box
    if (!this.quakeInRegion(quake)) {
      return null;
    }

    if (this.image.complete) {
      const latOffset = this.bound.n - quake.latitude;
      const qLon = this.antemeridianLongitude(quake.longitude);
      const bW = this.antemeridianLongitude(this.bound.w);
      const lngOffset = qLon - bW;
      return new ImageCoordinate(lngOffset * this.lngDegPixels, latOffset * this.latDegPixels);
    } else {
      console.log('Image not loaded');
      return null;
    }
  }

  antemeridianLongitude(longitude: number): number {
    return this.antemeridian ? ((longitude + 360) % 360) : longitude;
  }

  quakeInRegion(quake: Quake | MapCoordinate): boolean {
    const qLon = this.antemeridianLongitude(quake.longitude);
    const bW = this.antemeridianLongitude(this.bound.w);
    const bE = this.antemeridianLongitude(this.bound.e);
    if (quake.latitude <= this.bound.n &&
      quake.latitude >= this.bound.s &&
      qLon >= bW &&
      qLon <= bE
    ) {
      return true;
    }
    return false;
  }

  loadImage(): Observable<HTMLImageElement> {
    const observer = new Subject<HTMLImageElement>();
    if (this.image && this.image.src.indexOf(this.asset) > -1 && this.image.complete) {
      return of(this.image);
    }
    this.image = new Image();
    this.image.src = this.asset;
    this.image.onload = () => {
      const bW = this.antemeridianLongitude(this.bound.w);
      const bE = this.antemeridianLongitude(this.bound.e);
      this.lngDegPixels = this.image.width / (bE - bW);
      this.latDegPixels = this.image.height / (this.bound.n - this.bound.s);
      observer.next(this.image);
      observer.complete();
    };
    this.image.onerror = (err) => {
      observer.error(err);
      observer.complete();
    };
    return observer;
  }

}

